import React from "react";
import "./sectionEight.css";
import Section8Element from "../section8Element/section8Element";
import section8Img1 from "../../assets/section8Img1.png";
import section8Img2 from "../../assets/section8Img2.png";
import section8Img3 from "../../assets/section8Img3.png";
import section8Img4 from "../../assets/section8Img4.png";
import section8Img5 from "../../assets/section8Img5.png";
import MobileSlider from "../../mobileSlider/mobileSlider";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
const SectionEight = () => {
  // var settings = {
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 5000,
  // };
  return (
    <div className="sectionEight-main-wrapper" style={{marginTop: '-5px'}}>
      <div className="sectionEight-inner-wrapper">
        <div className="mypc">
          <div className="sectionEight-heading">
            <h1>THE TEAM</h1>
          </div>
          <div className="sectionEight-pic-wrapper">
            <Section8Element
              section8Imgs={section8Img1}
              section8ImgName={"Egor Koulechov"}
              section8ImgFounder={"Founder and CEO"}
              address={"https://twitter.com/RussianGusta"}
            />
            <Section8Element
              section8Imgs={section8Img2}
              section8ImgName={"Akil Mitchell"}
              section8ImgFounder={"Director of Operations"}
              address={" https://twitter.com/ajmitchell25"}
              />
            <Section8Element
              section8Imgs={section8Img3}
              section8ImgName={"Joey Sabo"}
              section8ImgFounder={"Head of Marketing"}
              address={"https://twitter.com/JoeySabo"}
              />
            <Section8Element
              section8Imgs={section8Img4}
              section8ImgName={"Kelly Streeter"}
              section8ImgFounder={"Social Media Manager"}
              address={" https://twitter.com/kelly_streeter"}
              />
            <Section8Element
              section8Imgs={section8Img5}
              section8ImgName={"Matias Lopez"}
              section8ImgFounder={"Digital Artist"}
            />
          </div>
        </div>
          <div className="mymob" style={{width: '100vw', marginLeft: '43px'}}>
            <MobileSlider numberOfSlides={1} title="THE TEAM">
              <div>
            <Section8Element
              section8Imgs={section8Img1}
              section8ImgName={"Egor Koulechov"}
              section8ImgFounder={"Founder and CEO"}
              address={"https://twitter.com/RussianGusta"}
            />
          </div>
          <div>
            <Section8Element
              section8Imgs={section8Img2}
              section8ImgName={"Akil Mitchell"}
              section8ImgFounder={"Director of Operations"}
              address={" https://twitter.com/ajmitchell25"}
            />
          </div>
          <div>
            <Section8Element
              section8Imgs={section8Img3}
              section8ImgName={"Joey Sabo"}
              section8ImgFounder={"Head of Marketing"}
              address={"https://twitter.com/JoeySabo"}
            />
          </div>
          <div>
            <Section8Element
              section8Imgs={section8Img4}
              section8ImgName={"Kelly Streeter"}
              section8ImgFounder={"Social Media Manager"}
              address={" https://twitter.com/kelly_streeter"}
              />
          </div>
          <div>
            <Section8Element
              section8Imgs={section8Img5}
              section8ImgName={"Matias Lopez"}
              section8ImgFounder={"Digital Artist"}
            />
          </div>
            </MobileSlider>
          </div>
      </div>
    </div>
  );
};

export default SectionEight;
